module.exports = __webpack_public_path__ + "img/favicon.148b9ab6.png";